import { mediaApi } from '@/services/mediaApi';

/**
 * A story's cover, in the order the server-rendered listing resolved it: an admin-uploaded PUBLIC
 * media asset wins; failing that, the slug convention /img/news/{slug}.jpg (the V018-seeded rows
 * never got a cover_media_asset_id). When neither exists the image fails to load and the caller
 * hides it, so the coloured panel behind it shows instead of a broken-image icon.
 *
 * In common because two features draw it — the public cards and the admin table's thumbnail — and
 * they had each written the rule out.
 */
export function newsCoverUrl(card: { slug: string; coverMediaAssetId?: string | null }): string {
  return card.coverMediaAssetId
    ? mediaApi.downloadUrl(card.coverMediaAssetId)
    : `/img/news/${card.slug}.jpg`;
}
